import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sync mr-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1)
const _hoisted_6 = { class: "grid grid-cols-4 gap-2" }
const _hoisted_7 = { class: "flex justify-end" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1)
const _hoisted_10 = { class: "mt-6" }
const _hoisted_11 = {
  key: 1,
  class: "flex items-center justify-center mt-3 bg-white rounded py-3 px-4"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Загрузка списка...", -1)
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "flex items-center justify-end bg-white rounded py-3 px-4" }
const _hoisted_15 = { class: "overflow-hidden overflow-x-auto" }
const _hoisted_16 = { class: "flex items-center gap-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sync" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_waba_create_template_modal = _resolveComponent("waba-create-template-modal")!
  const _component_waba_update_template_modal = _resolveComponent("waba-update-template-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_create_modal_opened)
      ? (_openBlock(), _createBlock(_component_waba_create_template_modal, {
          key: 0,
          onCancel: _ctx.onCreateCancel,
          onCreated: _ctx.onCreated
        }, null, 8, ["onCancel", "onCreated"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_update_modal_opened)
      ? (_openBlock(), _createBlock(_component_waba_update_template_modal, {
          key: 1,
          template: _ctx.state.update_modal_template,
          onCancel: _ctx.onUpdateCancel,
          onUpdated: _ctx.onUpdated
        }, null, 8, ["template", "onCancel", "onUpdated"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Шаблоны WABA" }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isCanSharedSync)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 0,
              type: "button",
              class: "small primary",
              loading: _ctx.state.is_shared_sync_loading,
              onClick: _ctx.onSharedSync
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createTextVNode(" Синхронизировать шаблоны ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isCanCreate)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 1,
              type: "button",
              class: "small primary",
              onClick: _ctx.onCreate
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(" Добавить шаблон ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("form", {
      class: "mt-5 bg-white border px-4 py-2",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.loadTemplates(1)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_the_input, {
          value: _ctx.filters.search,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.search) = $event)),
          placeholder: "Поиск по тексту",
          disabled: _ctx.data_state.templates.is_loading
        }, null, 8, ["value", "disabled"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          value: _ctx.filters.status,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.status) = $event)),
          "can-deselect": "",
          placeholder: "Статус",
          "select-by": "value",
          label: "label",
          searchable: false,
          disabled: _ctx.data_state.templates.is_loading || _ctx.data_state.statuses.is_loading,
          loading: _ctx.data_state.statuses.is_loading,
          failed: _ctx.data_state.statuses.is_failed,
          options: _ctx.data_state.statuses.list,
          onRefresh: _ctx.loadStatuses
        }, null, 8, ["value", "disabled", "loading", "failed", "options", "onRefresh"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          value: _ctx.filters.language,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.language) = $event)),
          "can-deselect": "",
          placeholder: "Язык",
          "select-by": "value",
          label: "label",
          searchable: false,
          disabled: _ctx.data_state.templates.is_loading || _ctx.data_state.languages.is_loading,
          loading: _ctx.data_state.languages.is_loading,
          failed: _ctx.data_state.languages.is_failed,
          options: _ctx.data_state.languages.list,
          onRefresh: _ctx.loadLanguages
        }, null, 8, ["value", "disabled", "loading", "failed", "options", "onRefresh"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          value: _ctx.filters.category,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.category) = $event)),
          "can-deselect": "",
          placeholder: "Категория",
          "select-by": "value",
          label: "label",
          searchable: false,
          disabled: _ctx.data_state.templates.is_loading || _ctx.data_state.categories.is_loading,
          loading: _ctx.data_state.categories.is_loading,
          failed: _ctx.data_state.categories.is_failed,
          options: _ctx.data_state.categories.list,
          onRefresh: _ctx.loadCategories
        }, null, 8, ["value", "disabled", "loading", "failed", "options", "onRefresh"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_the_button, {
          class: "second text small mt-2",
          disabled: _ctx.data_state.templates.is_loading,
          onClick: _ctx.reset
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary text small mt-2",
          loading: _ctx.data_state.templates.is_loading,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.data_state.templates.is_failed && !_ctx.data_state.templates.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.data_state.templates.is_loading,
            text: "При получении данных произошла ошибка",
            "error-message": _ctx.data_state.templates.failure.error_state.message,
            "error-url": _ctx.data_state.templates.failure.error_state.url,
            "error-status": _ctx.data_state.templates.failure.error_state.status,
            onRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadTemplates(_ctx.data_state.templates.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_ctx.data_state.templates.is_loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_loader, { class: "primary mr-1" }),
              _hoisted_12
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_new_limit, {
                  disabled: _ctx.data_state.templates.is_loading,
                  value: _ctx.data_state.templates.pagination.limit,
                  "total-items": _ctx.data_state.templates.pagination.total_items,
                  onChange: _ctx.onLimitChange
                }, null, 8, ["disabled", "value", "total-items", "onChange"]),
                _createVNode(_component_new_pagination, {
                  class: "ml-6",
                  disabled: _ctx.data_state.templates.is_loading,
                  "current-page": _ctx.data_state.templates.pagination.current_page,
                  "total-pages": _ctx.data_state.templates.pagination.total_pages,
                  onChangePage: _ctx.onChangePage
                }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_new_table, {
                  columns: _ctx.TABLE_COLUMNS,
                  rows: _ctx.data_state.templates.list
                }, {
                  td: _withCtx(({ column, row }) => [
                    (column.key === 'category')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (row.category)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(row.category.label), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("-")
                              ], 64))
                        ], 64))
                      : (column.key === 'status')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (row.status)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(row.status.label), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("-")
                                ], 64))
                          ], 64))
                        : (column.key === 'text')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(_toDisplayString(_ctx.cut(row.text, 15)), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                            ], 64))
                  ]),
                  actions: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_16, [
                      (_ctx.isCanUpdate)
                        ? (_openBlock(), _createBlock(_component_the_button, {
                            key: 0,
                            hint: "Редактировать",
                            class: "yellow extra-small",
                            onClick: ($event: any) => (_ctx.onUpdate(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_17
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.isCanDelete)
                        ? (_openBlock(), _createBlock(_component_the_button, {
                            key: 1,
                            disabled: _ctx.state.is_delete_loading,
                            loading: _ctx.state.is_delete_loading,
                            hint: "Удалить",
                            class: "red extra-small",
                            onClick: ($event: any) => (_ctx.onDelete(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_18
                            ]),
                            _: 2
                          }, 1032, ["disabled", "loading", "onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.isCanSync)
                        ? (_openBlock(), _createBlock(_component_the_button, {
                            key: 2,
                            disabled: _ctx.state.is_sync_loading,
                            loading: _ctx.state.is_sync_loading,
                            hint: "Синхронизировать",
                            class: "primary extra-small",
                            onClick: ($event: any) => (_ctx.onSync(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_19
                            ]),
                            _: 2
                          }, 1032, ["disabled", "loading", "onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["columns", "rows"])
              ])
            ]))
    ])
  ]))
}